export const CopyToClipboard = (ref: any) : Promise<object> => {
	return new Promise(((resolve, reject) => {
		try {
			ref.current.select();
			document.execCommand('copy');
			ref.current.blur();
			resolve();
		}
		catch (e) {
			console.log(e);
			reject(e);
		}
	}));
};

export default CopyToClipboard;


// WEBPACK FOOTER //
// ./src/pages/league/invites/copyToClipboard.js